import { render } from "./ContentPage.vue?vue&type=template&id=132e9d64"
import script from "./ContentPage.vue?vue&type=script&lang=js"
export * from "./ContentPage.vue?vue&type=script&lang=js"

import "./ContentPage.vue?vue&type=style&index=0&id=132e9d64&lang=scss"
script.render = render

export default script